module.exports = __webpack_public_path__ + "img/demo_man.fd836309.svg";